import { useState } from 'react';
import { faqItems } from '@/mocks/movies';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqItems.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  };

  return (
    <>
      <section className="py-10 md:py-14" aria-label="常见问题">
        <div className="max-w-[1400px] mx-auto px-4 md:px-6">
          <div className="text-center mb-8">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-100 mb-3">
              常见问题
            </h2>
            <p className="text-foreground-500 text-sm max-w-xl mx-auto">
              关于星空电影网的使用，您可能想了解的问题都在这里
            </p>
          </div>
          <div className="max-w-3xl mx-auto space-y-3">
            {faqItems.map((item, index) => (
              <div
                key={index}
                className="rounded-lg bg-background-100 border border-background-200/50 overflow-hidden"
              >
                <button
                  onClick={() => toggleFAQ(index)}
                  className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-200/30 transition-colors"
                  aria-expanded={openIndex === index}
                >
                  <span className="text-sm font-medium text-foreground-100 pr-4">
                    {item.question}
                  </span>
                  <i
                    className={`ri-arrow-down-s-line text-foreground-400 text-lg transition-transform duration-200 flex-shrink-0 ${
                      openIndex === index ? 'rotate-180' : ''
                    }`}
                  ></i>
                </button>
                <div
                  className={`transition-all duration-300 overflow-hidden ${
                    openIndex === index ? 'max-h-96' : 'max-h-0'
                  }`}
                >
                  <p className="px-5 pb-4 text-sm text-foreground-500 leading-relaxed">
                    {item.answer}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(faqSchema),
        }}
      />
    </>
  );
}